import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    ajax_url: "",
    ajax: {},
    firebase: {},
};

const configSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        setup: (state, action) => ({
            ...state,
            ...action.payload,
        }),
    },
});

export const { setup } = configSlice.actions;
export const config = configSlice.reducer;
